<template>
  <div class="mb-3">
    <custom-callout border-color="secondary-2" :has-toggle="false">
      <div class="row p-2">
        <div class="col-md-2">
          <div class="color-secondary-6 font-14">
            Año Académico:
          </div>
          <div class="font-weight-bold color-black font-14">
            {{ data.academicYear }}
          </div>
        </div>
        <div class="col-md-2">
          <div class="color-secondary-6 font-14">
            Área:
          </div>
          <div class="font-weight-bold color-black font-14">
            {{ data.area }}
          </div>
        </div>
        <div class="col-md-2">
          <div class="color-secondary-6 font-14">
            Tipo de Proveedor:
          </div>
          <div class="font-weight-bold color-black font-14">
            {{ data.recruitmentName }}
          </div>
        </div>
        <div class="col-md-2">
          <div class="color-secondary-6 font-14">
            Fecha de Última Actualización:
          </div>
          <div class="font-weight-bold color-black font-14">
            {{ data.lastUpdateDate | date }}
          </div>
        </div>
        <div class="col-md-2">
          <div class="color-secondary-6 font-14">
            Usuario:
          </div>
          <div class="font-weight-bold color-black font-14">
            {{ data.userFullName }}
          </div>
        </div>
        <div
          class="col-md-2 text-right d-flex justify-content-end pr-4 align-items-center"
        >
          <action-button
            class="ml-3"
            i="fas fa-file-import"
            text="Entrar"
            variant="outline-success"
            @click="() => this.onEditHandler()"
          />
        </div>
      </div>
    </custom-callout>
  </div>
</template>

<script>
import CustomCallout from 'custom-callout';
import ActionButton from 'ActionButton';

export default {
  name: 'ResultRow',
  components: {
    CustomCallout,
    ActionButton,
  },
  props: {
    data: {
      type: Object,
      default: () => {},
    },
  },
  computed: {},
  methods: {
    onEditHandler() {
      this.$router.push({
        name: 'DocumentConfigurationDetail',
        params: { id: this.data.id },
      });
    },
  },
};
</script>
